import { blogTypes } from 'redux/actionTypes/blogTypes';

export const setPosts = (postArray: any) => {
  return {
    type: blogTypes.set,
    payload: postArray,
  };
};

export const setTag = (tagArray: any) => {
  return {
    type: blogTypes.setTag,
    payload: tagArray,
  };
};
